export function timeAgo(dateString: string): string {
  const seconds = Math.floor((Date.now() - new Date(dateString).getTime()) / 1000)
  if (seconds < 60) return 'less than a minute'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} minutes`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `about ${hours} hours`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days} days`
  const months = Math.floor(days / 30)
  if (months < 12) return `${months} months`
  const years = Math.floor(days / 365)
  return `about ${years} years`
}
